import { render, staticRenderFns } from "./FileUploadButton.vue?vue&type=template&id=bd1a98a2&scoped=true&"
import script from "./FileUploadButton.vue?vue&type=script&lang=js&"
export * from "./FileUploadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1a98a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
